export default {
	'createAccount.title': '¡Estás a un paso de crearte una cuenta!',
};
